import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const NRTCardWithShadow = (props) => {
    return (
        <div className={'nrt-card-with-shadow ' + props.className }
             style={{...props.style}}>
            {props.children}
        </div>
    )
}

NRTCardWithShadow.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
}

NRTCardWithShadow.defaultProps = {}

export default NRTCardWithShadow



// WEBPACK FOOTER //
// ./src/components/_common/CardWithShadow/index.js